import type { ReactElement } from "react";
import { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import Loading from "../components/app/Loading";
import AppShell from "../containers/App";
import useDeploymentReload from "./useDeploymentReload";

const fallback = (
  <div className="main-content">
    <div className="page-content">
      <Loading />
    </div>
  </div>
);

export default function RouterAppShell(): ReactElement {
  const location = useLocation();
  const captureDeploymentNavigation = useDeploymentReload();

  return (
    <AppShell location={location} onClickCapture={captureDeploymentNavigation}>
      <Suspense fallback={fallback} key={location.pathname}>
        <Outlet />
      </Suspense>
    </AppShell>
  );
}
